module.exports = __webpack_public_path__ + "static/media/Products.d579b2d9.png";